module.exports = __webpack_public_path__ + "img/597.85c565d5.jpg";